import { createStore, withProps } from '@ngneat/elf';
import { Company, CompanyDetails, CompanyDto } from '@/types';
import { SelectOption } from '../../components/form-builder/form-builder.types';
import { refParamsFactory } from '../ref-param-state/ref-param-state.store';

export interface CompanyStateProps {
  response?: Partial<CompanyDetails | Company>;
  dto?: Partial<CompanyDto>;
  companyTypeSelected?: SelectOption;
  companyCountrySelected?: SelectOption;
  companyCategorySelected?: SelectOption;
}

export const companyStateInitialState: CompanyStateProps = {
  response: {
    id: 0,
    nom: '',
    nif: '',
    dateNif: new Date(),
    numCnss: '',
    status: false,
    categorieSoumissionnaire: structuredClone(refParamsFactory()),
    type: structuredClone(refParamsFactory()),
  },
  dto: { nom: '', typeId: 0, nif: '', dateNif: new Date(), categorieSoumissionnaireId: 0, numCnss: '' },
  companyTypeSelected: { name: '', code: 0 },
  companyCategorySelected: { name: '', code: 0 },
  companyCountrySelected: { name: '', code: 0 },
};

export const companyStateStore = createStore({ name: 'company-state' }, withProps<CompanyStateProps>(companyStateInitialState));
